<template>
  <el-dialog
  :visible="visible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  append-to-body
  center
  v-loading.fullscreen.lock="fullScreenLoading"
  @open="open">
  <span slot="title" class="dialog-header">
    <span  class="title" >{{ $t('communications.notice') }}</span>
  </span>
  <el-form class="formContainer">
    <el-row>
      <el-col>
        <el-form-item :label="$t('communications.sendTo')" :error="errorIfSendToEmpty">
          <el-select
            v-model="sendTo"
            multiple
            allow-create
            filterable
            value-key="id"
            @change="sendToChanged">
            <el-option
              v-for="contact in contactList"
              :key="contact.id"
              :label="getName(contact)"
              :value="contact">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-form-item :label="$t('common.language')">
          <el-radio-group v-model="emailLanguageCode" size="small" @change="languageChange">
            <el-radio v-for="lang in languages" :key="lang.id" :label="lang.code" border>{{lang.label}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-form-item :label="$t('communications.includeFile')">
          <el-switch v-model="attachment" :disabled="forceSendAttachment || type === 'CUSTOMER_STATEMENT'"/>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form-item :label="$t('communications.personalizedEmail')" v-loading="contentRefreshing">
          <el-select v-model="emailCustomContent" clearable @change="handleChangeTemplate" value-key="id">
            <el-option
              v-for="item in emailCustomContentList"
              :key="item.id"
              :label="item.description"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form-item :label="$t('communications.personalizedContent')">
          <quill-editor v-model="emailContent" @change="refreshContent" style="margin-top:40px;border:1px solid #EBEEF5"
            ref="noteEditor"
            :options="editorOptions">
          </quill-editor>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form-item :label="$t('communications.preview')" v-loading="contentRefreshing">
            <div v-if="previewAvailable" style="min-height:200px;margin-top:40px;border:1px solid #EBEEF5;line-height:1em;" v-html="htmlContent"></div>
            <div v-else style="height:200px;border:1px solid #EBEEF5;text-align:center;margin-top:40px;padding-top:100px"><span>{{ $t('communications.previewNotAvailable') }}</span></div>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>

  <span slot="footer" class="dialog-footer card-shadow--large">
    <el-button @click="closeDialog">{{ $t('common.Cancel') }}</el-button>
    <el-button type="primary" @click="send" :disabled="!previewAvailable || fullScreenLoading">{{$t('buttons.send')}}</el-button>
  </span>
  </el-dialog>
</template>
<script>

import { mapActions, mapState, mapGetters } from 'vuex';
import invoiceAPI from '@/services/API/invoice'
import creditNoteAPI from '@/services/API/creditNote'
import customerAPI from '@/services/API/customer'
// import eccAPI from '@/services/API/emailCustomContent'


export default {
  name: 'SendNoticeDialog',
	props: {
		visible : Boolean,
    type: {
      type: String
    },
    customerId: {
      type: Number,
    },
    object : null,
    contacts : null,
    language : null,
    forceSendAttachment: {
      type: Boolean,
      default : false
    },
	},
  data() {
    return {
      customer : null,
      contactList : [],
      sendTo : [],
      editorOptions: {
				theme: 'bubble',
        placeholder:"",
        modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike']
					]
				}
			},
      fullScreenLoading:false,
      emailContent : "",
      htmlContent : "",
      contentRefreshing : false,
      attachment: false,
      languages : [{
        id:1,
        code : 'fr',
        label : "Français"
      },{
        id:2,
        code : 'en',
        label:"English"
      }],
      emailLanguageCode : 'fr',
      emailCustomContent : null,
    };
  },components: {

  },
	methods: {
    addToContactList(contact){
      let contactFound = _.find(this.contactList, c=>{ return c.id==contact.id });
      if(!contactFound){
        this.contactList.push({id : contact.id, last_name : contact.last_name, first_name : contact.first_name, email : contact.work_email!=null && contact.work_email!='' ? contact.work_email : contact.email, default_billing_ind:contact.default_billing_ind,send_invoice_notice_ind:contact.send_invoice_notice});
      }
    },
    handleChangeTemplate(template){
      if(template==null || template==''){
        this.resetEmailContent();
      }else{
        this.initEmailContent(template.content[this.emailLanguageCode]);
      }
    },
    getEmail(contact){
      return contact.work_email!=null && contact.work_email!='' ? contact.work_email : contact.email;
    },
    getName(contact){
      if((contact.first_name==null || contact.first_name==='') && (contact.last_name==null || contact.last_name==='')){
				return "Unnamed contact" + "("+this.getEmail(contact)+")";
			}
			return contact.first_name + " " + contact.last_name + "("+this.getEmail(contact)+")";
    },
    sendToChanged(){
      this.refreshPreview();
    },
    languageChange(value){
      if(this.emailCustomContent!=null){
        this.emailContent = this.emailCustomContent.content[this.emailLanguageCode];
      }else{
        this.resetEmailContent();
      }
      this.refreshPreview();
    },
    closeDialog(){
      this.sendTo = [];
      this.emailContent = "";
      this.htmlContent = "";
      this.contentRefreshing=false;
      this.emailCustomContent = null;
      this.attachment = false;
      this.$emit('close');
    },
    refreshPreview(){
      if(this.previewAvailable){
        this.contentRefreshing=true;
        if (this.type === 'INVOICE') {
          console.log('Refresh Preview : INVOICE');
          invoiceAPI.previewInvoiceNotification(this.object.id, {content:this.emailContent,first_name:this.sendTo[0].first_name,last_name:this.sendTo[0].last_name, language:this.emailLanguageCode, currency:this.invoice.currency.code})
          .then(htmlNotification=>{
            this.htmlContent = htmlNotification;
            this.contentRefreshing=false;
          })
        } else if (this.type === 'CREDIT_NOTE') {
          // CREDIT NOTE
          // TODO
          creditNoteAPI.previewCreditNoteNotification(this.object.id, {content:this.emailContent,first_name:this.sendTo[0].first_name,last_name:this.sendTo[0].last_name, language:this.emailLanguageCode, currency:this.object.currency.code})
          .then(htmlNotification=>{
            this.htmlContent = htmlNotification;
            this.contentRefreshing=false;
          })
        } else if (this.type === 'CUSTOMER_STATEMENT') {
          // CREDIT NOTE
          // TODO
          customerAPI.previewCustomerStatementNotification(this.customerId, {content:this.emailContent,first_name:this.sendTo[0].first_name,last_name:this.sendTo[0].last_name, language:this.emailLanguageCode})
          .then(htmlNotification=>{
            this.htmlContent = htmlNotification;
            this.contentRefreshing=false;
          })
        }
        
      }else{
        this.contentRefreshing=false;
      }

    },
    refreshContent(quillEvent){
      let _this = this;
      if(!this.contentRefreshing){
        this.contentRefreshing=true;
        setTimeout(function(){ _this.refreshPreview();}, 1000);
      }
    },
    addToSendTo(contact){

      let contactFound = _.find(this.sendTo, c=>{return c.id==contact.id});
      if(!contactFound){
        this.sendTo.push({id : contact.id, last_name : contact.first_name, first_name : contact.first_name, email : contact.work_email!=null && contact.work_email!='' ? contact.work_email : contact.email});
      }
    },
    open(){
      this.fullScreenLoading=true;
      this.resetEmailContent();
      
      
      return customerAPI.getCustomer(this.customerId)
        .then(customer=>{
          
          this.emailLanguageCode = _.get(customer, 'language.code');
          this.customer = customer;

          if (this.type === 'CUSTOMER_STATEMENT') {
            this.emailCustomContent = _.find(this.emailCustomContent, t=>{return t.id==customer.email_custom_content.CUSTOMER_STATEMENT_NOTICE})
            console.log("email custom content for customer statement", this.emailCustomContent);
            if(this.emailCustomContent!=null)this.emailContent=this.emailCustomContent.content[this.emailLanguageCode];
          }

          if (this.emailCustomContent == null) {
            this.emailContent = this.defaultEmailContent;
          }

          // if(customer.email_custom_content!=null && customer.email_custom_content.INVOICE_NOTICE!=null){
          //   this.emailCustomContent = _.find(this.emailCustomContent, t=>{return t.id==customer.email_custom_content.INVOICE_NOTICE})
          //   console.log("email custom content for invoice notice", this.emailCustomContent);
          //   if(this.emailCustomContent!=null)this.emailContent=this.emailCustomContent.content[this.emailLanguageCode];
          // } else if(customer.email_custom_content!=null && customer.email_custom_content.CREDIT_NOTE_NOTICE!=null){
          //   this.emailCustomContent = _.find(this.emailCustomContent, t=>{return t.id==customer.email_custom_content.CREDIT_NOTE_NOTICE})
          //   if(this.emailCustomContent!=null)this.emailContent=this.emailCustomContent.content[this.emailLanguageCode];
          //   console.log("email custom content for credit note notice", this.emailCustomContent);
          // } else if(customer.email_custom_content!=null && customer.email_custom_content.CUSTOMER_STATEMENT_NOTICE!=null){
          //   this.emailCustomContent = _.find(this.emailCustomContent, t=>{return t.id==customer.email_custom_content.CUSTOMER_STATEMENT_NOTICE})
          //   console.log("email custom content for customer statement", this.emailCustomContent);
          //   if(this.emailCustomContent!=null)this.emailContent=this.emailCustomContent.content[this.emailLanguageCode];
          // }

          this.attachment = (this.forceSendAttachment || this.type === 'CUSTOMER_STATEMENT') ? true : customer.send_invoice_in_attachment;
          // On regarde si le prop est vide. Si oui, alors on prend les contacts sur le client.
          if(_.isEmpty(this.contacts)){
            this.contactList = [];

            //On popule la liste des contacts
            if(customer.company != null){
              _.forEach(customer.company.contacts, (c) =>{
                  if (c.active) { this.addToContactList(c); }
              })
            } else { 
              this.addToContactList(customer.contact);
            }
          } else {
            _.forEach(this.contacts, c=>{
              this.addToContactList(c);
            })
          }
          return this.customer;


        }).then((customer)=>{
          this.initSendTo();
          this.refreshPreview();
          this.fullScreenLoading=false;
          
        }).catch(err=>{
          console.log(err);
          this.fullScreenLoading=false;
          this.closeDialog();
          this.$message.error('Une erreur système est survenue. Veuillez réessayer plus tard');
        })
    },
    initSendTo(){

      if(this.contactList.length==1){
        this.addToSendTo(this.contactList[0]);
      }
      _.forEach(this.contactList, c=>{
          if(_.get(this.object, 'billing_contact.id') != null) this.addToSendTo(c);
          else if(c.default_billing_ind) this.addToSendTo(c);
          else if(c.send_invoice_notice_ind) this.addToSendTo(c);

      })

    },
    initEmailContent(content){
      this.emailContent = content;
    },
    resetEmailContent(){
      this.emailContent = this.defaultEmailContent;
    },
    send(){
      this.fullScreenLoading = true;
      if (this.type === 'INVOICE') {
        invoiceAPI.sendInvoiceNotification(this.object.id,this.sendTo,this.emailContent,this.emailLanguageCode, this.attachment)
        .then(()=>{
          this.$emit('sent');
          this.fullScreenLoading = false;
          this.closeDialog();
        }).catch(err=>{
          this.fullScreenLoading = false;
          console.log(err);
        })
      } else if (this.type === 'CREDIT_NOTE') {
        creditNoteAPI.sendCreditNoteNotification(this.object.id,this.sendTo,this.emailContent,this.emailLanguageCode, this.attachment)
        .then(()=>{
          this.$emit('sent');
          this.fullScreenLoading = false;
          this.closeDialog();
        }).catch(err=>{
          this.fullScreenLoading = false;
          console.log(err);
        })
      } else if (this.type === 'CUSTOMER_STATEMENT') {
        console.log("send customer statement notice with content : ", this.emailContent);
        customerAPI.sendSimpleStatementNotification(this.object.id,this.sendTo,this.emailContent,this.emailLanguageCode, this.attachment)
        .then(()=>{
          this.$emit('sent');
          this.fullScreenLoading = false;
          this.closeDialog();
        }).catch(err=>{
          this.fullScreenLoading = false;
          console.log(err);
        })
      }


      
      // customerAPI.updateCustomerSettings({
      //   email_custom_content : {
      //     INVOICE_NOTICE:this.emailCustomContent != null ? this.emailCustomContent.id : 'null'
      //   },
      //   sendInvoiceInAttachment: this.attachment,
      //   },
      //   this.invoice.customer.id);
    },
    ...mapActions('controlData',['fetchEmailCustomContent'])
	},
	computed: {
    emailCustomContentList(){
      if (this.type === 'INVOICE') {
        return this.invoiceNoticeEmailCustomContent;
      } else if (this.type === 'CREDIT_NOTE') {
        return this.creditNoteNoticeEmailCustomContent;
      } else if (this.type === 'CUSTOMER_STATEMENT') {
        return this.creditCustomerStatementNoticeEmailCustomContent;
      }
    },
    defaultEmailContent(){
      if (this.type === 'INVOICE'){
        return this.$i18n.t('invoices.notification.default_'+this.emailLanguageCode);
      } else if (this.type === 'CREDIT_NOTE'){
        return this.$i18n.t('credit_notes.notification.default_'+this.emailLanguageCode);
      } else if (this.type === 'CUSTOMER_STATEMENT'){
        return this.$i18n.t('clients.notification.default_'+this.emailLanguageCode);
      }
    },
    previewAvailable(){
      return (this.sendTo.length>0);
    },
    errorIfSendToEmpty(){
      if(this.sendTo.length>0){
        return null;
      }else{
        return this.$i18n.t('communications.contactSelectionWarning');
      }
    },
    ...mapGetters('controlData',['invoiceNoticeEmailCustomContent', 'creditNoteNoticeEmailCustomContent', 'creditCustomerStatementNoticeEmailCustomContent'])
	},
  created(){
    this.fetchEmailCustomContent();
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/_variables';


.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-20px;
  padding-top:10px;
  border-top:1px solid #E4E7ED;
  z-index:100;
}

.el-input__inner{
  border:0px;
}
.title {
	font-size : 1.6em;
	font-weight:bold;

}


.formContainer{
    margin-left:30%;
    width:50%;
  }


@media (max-width: 1366px) {
  .formContainer{
      margin-left:20%;
      width:60%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:15%;
      width:70%;
    }
}

</style>
